import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';

import { Shapes } from '../../models/entities';
import PageNavigator from '../pagination/PageNavigator';
import PageSizeSelector from '../pagination/PageSizeSelector';

const PaginationToolbar = (props) => {
  const {
    children, onChangePage, onChangePageSize, pagination,
  } = props;

  return (
    <>
      <Col>
        {children}
      </Col>
      <Col>
        <PageNavigator
          pagination={pagination}
          onChangePage={onChangePage}
        />
      </Col>
      <Col>
        <PageSizeSelector
          pagination={pagination}
          onChange={onChangePageSize}
        />
      </Col>
    </>
  );
};

PaginationToolbar.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  onChangePage: PropTypes.func.isRequired,
  onChangePageSize: PropTypes.func.isRequired,
  pagination: Shapes.PAGINATION.isRequired,
};

PaginationToolbar.defaultProps = {
  children: undefined,
};

export default PaginationToolbar;
